/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Onboarding_Pilot_Welcome_SubtitleInputs */



/**
* | output |
* | --- |
* | "Wundo is your personal sparring partner for the conversations that matter. Over the next {weeks} weeks you'll practise conversations that build on what you'r..." |
*
* @param {Onboarding_Pilot_Welcome_SubtitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_welcome_subtitle = /** @type {((inputs: Onboarding_Pilot_Welcome_SubtitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Welcome_SubtitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Wundo is je persoonlijk klankbord voor de gesprekken die ertoe doen. De komende ${i?.weeks} weken oefen je met gesprekken die aansluiten bij wat je in de opleiding leert.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Wundo est votre caisse de résonance personnelle pour les conversations qui comptent. Au cours des ${i?.weeks} prochaines semaines, vous vous entraînez à des conversations en lien avec ce que vous apprenez dans la formation.`)
	return /** @type {LocalizedString} */ (`Wundo is your personal sparring partner for the conversations that matter. Over the next ${i?.weeks} weeks you'll practise conversations that build on what you're learning in the programme.`)
});